import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Chat from './Chat';
import './Viewer.css';

const Viewer = () => {
  const [playbackId, setPlaybackId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('v');
    if (id) {
      setPlaybackId(id);
    }
    setIsLoading(false);
  }, [location]);

  if (isLoading) {
    return (
      <div className="viewer-container">
        <div className="loading">Loading stream...</div>
      </div>
    );
  }

  if (!playbackId) {
    return (
      <div className="viewer-container">
        <div className="error">
          <h2>Stream Not Found</h2>
          <p>No playback ID provided. Please check your URL and try again.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="viewer-container">
      <div className="video-section">
        <iframe
          src={`https://lvpr.tv?v=${playbackId}`}
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="Stream Player"
        />
      </div>

      <div className="chat-section">
        <Chat streamId={playbackId} />
      </div>
    </div>
  );
};

export default Viewer; 